"use client";

import { useRouter } from "next/navigation";
import { teamsData } from "@/features/landing/data";

export default function LandingTeam() {
  const router = useRouter();

  return (
    <section
      className="py-12 sm:py-16 bg-white overflow-hidden cursor-pointer"
      onClick={() => router.push("/about")}
    >
      <style jsx>{`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .scroll-container {
          animation: scroll-left 60s linear infinite;
          width: fit-content;
        }
        .scroll-container:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="max-w-6xl mx-auto px-6 mb-8 text-center">
        <p className="text-[11px] tracking-[0.25em] uppercase text-[#6b6b6b] font-winky mb-2">
          Team
        </p>
        <h2 className="text-[1.75rem] sm:text-[2.25rem] font-bold text-[#2d2d2d] font-winky leading-tight mb-2">
          Hoku &amp; The Humans
        </h2>
        <p className="text-[#6b6b6b] text-[14px] font-patrick leading-relaxed max-w-md mx-auto">
          Meet the brilliant, slightly over-caffeinated team behind Hoku.
        </p>
      </div>

      {/* Scrolling Container */}
      <div className="relative">
        {/* Gradient Overlays */}
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

        {/* Animated Cards Container */}
        <div className="scroll-container flex gap-6 px-6">
          {[...teamsData, ...teamsData].map((member, i) => (
            <div
              key={`${member.id}-${i}`}
              className="flex-shrink-0 w-72 sm:w-80 h-96 rounded-3xl overflow-hidden shadow-lg relative group cursor-pointer border border-black/5"
              style={{
                backgroundImage: `url(${member.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                <h3 className="text-xl sm:text-2xl font-bold font-winky mb-1">
                  {member.name}
                </h3>
                {member.designation && (
                  <p className="text-sm text-white/90 mb-2 font-semibold">
                    {member.designation}
                  </p>
                )}
                <p className="text-sm text-white/80 leading-relaxed">
                  {member.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
